import React from "react";
import {Path} from './style'

function DrawingLine({ line }) {
    const pathData = `M ${line.map(p => `${p.get('x')} ${p.get('y')}`).join(" L ")}`

    return <Path style={{fill: 'none', strokeWidth: '2px', stroke: '#000', strokeLinejoin: 'round', strokeLinecap: 'round'}} d={pathData} />;
}

export default DrawingLine